import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import { HeaderNav } from './HeaderNav';
import { HeroSection } from './HeroSection';
import PlayIcon from '../assets/playIcon.svg';

const DEMO_VIDEO_ID = '4pHZwNcRqB4';

export const HeroHeader: React.FC = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
      <style>{`
        .hero-header {
          position: relative;
          width: 100%;
          min-height: 100vh;
          min-height: 100dvh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-sizing: border-box;
          --hero-inline-padding: clamp(12px, 3vw, 24px);
        }

        .hero-header__nav {
          position: relative;
          z-index: 1;
          flex-shrink: 0;
          width: 100%;
        }

        .hero-header__nav > .container-fluid {
          padding-top: clamp(12px, 2dvh, 20px) !important;
          margin-bottom: clamp(16px, 2.5dvh, 40px) !important;
        }

        .hero-header__content {
          position: relative;
          z-index: 1;
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          min-height: 0;
          width: 100%;
        }

        .hero-header__content > .container-fluid {
          padding-top: clamp(0px, 1.5dvh, 24px) !important;
          padding-bottom: clamp(12px, 2dvh, 24px) !important;
          padding-left: var(--hero-inline-padding) !important;
          padding-right: var(--hero-inline-padding) !important;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 100%;
          box-sizing: border-box;
        }

        .hero-header__content .hero-section > .row {
          margin-left: 0;
          margin-right: 0;
          width: 100%;
        }

        .hero-header__content .hero-section > .row > [class*='col-'] {
          padding-left: 0;
          padding-right: 0;
        }

        .hero-header__footer {
          position: relative;
          z-index: 1;
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          box-sizing: border-box;
          padding-bottom: clamp(24px, 4dvh, 40px);
          padding-left: var(--hero-inline-padding);
          padding-right: var(--hero-inline-padding);
        }

        .hero-header__play-demo {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: clamp(8px, 1.2dvh, 10px) 16px;
          border: none;
          border-radius: 40px;
          background: rgba(255, 255, 255, 0.01);
          backdrop-filter: none;
          color: #ffffff;
          text-decoration: none;
          font-family: Inter, sans-serif;
          font-weight: 400;
          font-size: clamp(16px, 1.05vw, 20px);
          white-space: nowrap;
          cursor: pointer;
        }

        .hero-header__play-demo:hover {
          color: #ffffff;
          background: rgba(255, 255, 255, 0.04);
        }

        .hero-header__video-overlay {
          position: absolute;
          inset: 0;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.7);
          cursor: pointer;
        }

        .hero-header__video-frame {
          width: 60%;
          aspect-ratio: 16 / 9;
          max-height: 65%;
          border: none;
          border-radius: 8px;
          cursor: default;
        }

        @media (max-width: 991.98px) {
          .hero-header__nav > .container-fluid {
            padding-top: clamp(16px, 3dvh, 24px) !important;
            margin-bottom: clamp(8px, 1.5dvh, 16px) !important;
          }

          .hero-header__nav > .container-fluid > .row > .col {
            width: 100% !important;
          }

          .hero-header__content > .container-fluid {
            padding-top: 0 !important;
            padding-bottom: clamp(8px, 2dvh, 16px) !important;
          }

          .hero-header__footer {
            padding-bottom: clamp(20px, 5dvh, 39px);
          }

          .hero-header__video-frame {
            width: 100%;
            height: 55dvh;
            max-height: 75dvh;
            aspect-ratio: auto;
            border-radius: 0;
          }
        }
      `}</style>

      <section className="hero-header" aria-label="Hero">
        <div className="hero-header__nav">
          <HeaderNav />
        </div>

        <div className="hero-header__content">
          <HeroSection />
        </div>

        <footer className="hero-header__footer">
          <button
            type="button"
            className="hero-header__play-demo"
            onClick={() => setIsVideoOpen(true)}
          >
            <Image src={PlayIcon} alt="Play demo" height={24} />
            <span>Play Demo Video</span>
          </button>
        </footer>

        {isVideoOpen && (
          <div
            className="hero-header__video-overlay"
            role="presentation"
            onClick={() => setIsVideoOpen(false)}
          >
            <iframe
              className="hero-header__video-frame"
              src={`https://www.youtube.com/embed/${DEMO_VIDEO_ID}?autoplay=1`}
              title="Cero demo video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              onClick={(event) => event.stopPropagation()}
            />
          </div>
        )}
      </section>
    </>
  );
};
